import { format } from 'date-fns';

export function roundToNextQuarterHour(date) {
  const minutes = date.getMinutes();
  const roundedMinutes = Math.ceil(minutes / 15) * 15;
  date.setMinutes(roundedMinutes, 0, 0);
  return date;
}

export function roundToNextHalfHour(date) {
    const minutes = date.getMinutes();
    
    if (minutes <= 30) {
      date.setMinutes(30, 0, 0); // Round to 30 minutes past the hour
    } else {
      date.setHours(date.getHours() + 1); // Move to the next hour
      date.setMinutes(0, 0, 0); // Set minutes to 0
    }
  
    return date;
  }
  
  export function generateICSFile({ title, description, location, startDateTime, endDateTime, cancellationLink }) {
    // Beschreibung mit Zeilenumbrüchen und Stornierungslink
    const fullDescription = `${description}\\n\\nStornieren Sie Ihren Termin hier: ${cancellationLink}`;
  
    // ICS-Inhalt ohne Einrückungen erstellen
    const icsContent = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "BEGIN:VEVENT",
      `SUMMARY:${title}`,
      `DESCRIPTION:${fullDescription}`,
      `LOCATION:${location}`,
      `DTSTART:${format(startDateTime, "yyyyMMdd'T'HHmmss")}`,
      `DTEND:${format(endDateTime, "yyyyMMdd'T'HHmmss")}`,
      "BEGIN:VALARM",
      "TRIGGER:-PT24H",
      "ACTION:DISPLAY",
      "DESCRIPTION:Erinnerung: Ihr Termin ist in 24 Stunden",
      "END:VALARM",
      "BEGIN:VALARM",
      "TRIGGER:-PT2H",
      "ACTION:DISPLAY",
      "DESCRIPTION:Erinnerung: Ihr Termin ist in 2 Stunden",
      "END:VALARM",
      "END:VEVENT",
      "END:VCALENDAR",
      ""
    ].join("\r\n"); // Richtige Zeilenumbrüche gemäß ICS-Standard
  
    // Datei erstellen
    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
    return URL.createObjectURL(blob);
  }
  
  
